export default __webpack_public_path__ + "static/media/mexc-global.528099ab.jpg";